export default __webpack_public_path__ + "static/media/next.3a14e974.png";